import DataTable from "@mostrans/web-components/components/advanced/DataTable";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { Icon, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import Title from "../../../components/Layout/Title";
import { titleAtoms } from "../../../shared/atoms/titleAtoms";
import { useGetMasterClinic } from "../../../shared/hooks/useGetMasterData";

import { useApolloClient } from "@apollo/client";
import { useConfirmationModal } from "@mostrans/web-components/hooks/useConfirmationModal";
import { toast } from "react-toastify";
import { DeleteMasterClinicID } from "../../../GQL/mutations";
import ModalCreateClinic from "./ModalCreateClinic";
import ModalDetailClinic from "./ModalDetailClinic";

function Clinic() {
  const [listMasterClinic, fetchMasterClinic] = useGetMasterClinic();
  const [errInput, setErrInput] = useState(false);
  const [modalDetailClinic, setModalDetailClinic] = useState(false);
  const { showConfirmationModal } = useConfirmationModal();
  const [detailClinic, setDetailClinic] = useState();
  const [filterClinicName, setFilterClinicName] = useState();
  const [disableButton, setDisableButton] = useState(true);
  const client = useApolloClient();

  const setTitle = useSetRecoilState(titleAtoms);

  useEffect(() => {
    setTitle("Clinic");
  }, []);

  const handleOpenModalDetailClinic = async (data) => {
    await setDetailClinic(data);
    setModalDetailClinic(true);
    setDisableButton(true);
  };

  const handleCloseModalDetailClinic = () => {
    setModalDetailClinic(false);
    setDisableButton(true);
  };

  const column = [
    {
      getCellKey: (data) => "name" + data.id,
      selector: "clinic_name",
      header: "Clinic Name",
      sortBy: "clinic_name",
      sortable: true,
    },
    {
      getCellKey: (data) => "branch" + data.id,
      selector: "clinic_branch",
      header: "Clinic Branch",
      sortBy: "clinic_branch",
      sortable: true,
    },
    {
      getCellKey: (data) => "email" + data.id,
      renderCell: (data) => (
        data.detailClinic?.length > 0 ?
          data.detailClinic?.map((email) => (
            <p>{email.clinic_email}</p>
          ))
          : "-"
      ),
      selector: "clinic_email",
      header: "Clinic Email",
    },
    {
      getCellKey: (data) => "telp" + data.id,
      selector: "telp_number",
      header: "Telp. Number",
      sortBy: "telp_number",
      sortable: true,
    },
    {
      renderCell: (data) => (
        <>
          <Button onClick={() => handleOpenModalDetailClinic(data)}>
            Detail
          </Button>
          <Button color="error" onClick={() => deleteCLinic(data)}>
            Delete
          </Button>
        </>
      ),
      selector: "id",
      header: "Action",
    },
  ];


  const filterClinic = () => {
    const filteredClinic = listMasterClinic?.filter((clinic) => {
      return (
        clinic.clinic_name
          .toLowerCase()
          .match(filterClinicName?.toLowerCase()) ||
        clinic.clinic_branch
          .toLowerCase()
          .match(filterClinicName?.toLowerCase())
      );
    });
    return filteredClinic;
  };


  const deleteCLinic = async (value) => {
    const show = await showConfirmationModal({
      headerText: "Confirmation",
      deniedButtonText: "Cancel",
      confirmButtonText: "Confirm",
      headerIcon: <Icon>warning</Icon>,
      contentText: "Are you sure to delete clinic?",
      modalProps: {},
    });
    // respon.errMsg
    if (show.isConfirmed) {
      try {
        const responDelete = await DeleteMasterClinicID(client, value.id);
        if (responDelete.data.deleteMasterClinic.errMsg === "OK") {
          fetchMasterClinic();
          toast.success("Clinic Deleted", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(responDelete.data.deleteMasterClinic.errMsg, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        console.log(error, "Error Delete CLinic");
        alert(error);
      }
    }
  };

  return (
    <React.Fragment>
      {/* <ConfDeleteClinic /> */}
      <ModalDetailClinic
        modalDetailClinic={modalDetailClinic}
        handleCloseModalDetailClinic={handleCloseModalDetailClinic}
        detailClinic={detailClinic}
        disableButton={disableButton}
        setDisableButton={setDisableButton}
      />
      <div>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Title>Clinic Master</Title>
          <div className="form-row">
            <div className="col-md-6">
              <FormGroup>
                <Input
                  placeholder="Search By Clinic Name"
                  onChange={(e) => setFilterClinicName(e.target.value)}
                />
              </FormGroup>
            </div>
            <div
              className="col md-6"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <ModalCreateClinic
                errInput={errInput}
                setErrInput={setErrInput}
                fetchMasterClinic={fetchMasterClinic}
              />
            </div>
          </div>
          <div className="mt-2">
            <DataTable
              data={filterClinic()}
              columns={column}
              hasPagination={true}
              headerRowStyle={() => ({ fontSize: 13 })}
              conditionalRowStyle={() => ({ fontSize: 13 })}
            />
          </div>
        </Paper>
      </div>
    </React.Fragment>
  );
}

export default Clinic;
